export const SEND_TIMEOUT_MS = 15000
